module.exports = __webpack_public_path__ + "static/img/ddhzyk-img6.2800ec5b.jpg";